import cx from 'classnames';

import './FormRadioInput.scss';

export const FormRadioSlider = ({ id = 'switch', title, description, checked, disabled, onChange }) => {
  return (
    <div className={cx('form-radio__slider__container', { disabled: disabled })}>
      <div className="form-radio__slider__span">
        <input
          className="form-radio__slider__input"
          type="checkbox"
          id={id}
          disabled={disabled}
          checked={checked}
          onChange={e => {
            onChange(e);
          }}
        />
        <label className="form-radio__slider__label" htmlFor={id}></label>
      </div>
      <span className="form-radio__slider__span">
        <div className="d-flex flex-column gap-1">
          {title}
          {description && <span className="form-radio__slider__description">{description}</span>}
        </div>
      </span>
    </div>
  );
};
